import '../../App.css';
import { Container, Button, Navbar, Nav, NavItem, NavDropdown, MenuItem, NavLink,FormControl ,Form, FormLabel, Table, Alert} from 'react-bootstrap';
import React, { useState, Component } from 'react';
import {Sida,Rubrik,ContentWrapper,StyckeCompact,StyckeInternal} from "../ContentStyles";
import useBackend, {CallAPI, Loading} from '../../services/useBackend';
import {useParams, useNavigate} from 'react-router-dom';
import {DateTimeToLocal, MultiselectGetOptions, MultiselectGetDefaultValues, escapedNewLineToLineBreakTag, ConcatLocalDateAndTime2ISO, SplitoutLocalDateFromISO, SplitoutLocalTimeFromISO, getOptions} from '../../services/misc';

import {ModalAddShop} from './Shops';
import {ModalProductEdit} from './Products';
import { Branding, Helmetx } from '../../services/misc';

var typingTimeout = null;
var customerGUID = null;

export default function ControlPanel() {
    const {CustomerGUID} = useParams();
	customerGUID = CustomerGUID;

    const [bankAccount, setBankAccount] = useState({ClnrNumber: "", AccountNumber : "", BankName : ""}); 
    const {loading, data, Refresh} =  useBackend('/api/admin/myinstance');

    const { loading: registerDataLoading, data: registerData } = useBackend(process.env.PUBLIC_URL + '/api/admin/Register');

    const [modalshowAddShop,  setModalshowAddShop] = useState(false);    
    const initModalAddShop = () => { return setModalshowAddShop(!modalshowAddShop) }     

    const [modalshowAddProduct,  setModalshowAddproduct] = useState(false);    
    const initModalAddProduct = () => { return setModalshowAddproduct(!modalshowAddProduct) }

    const defaultProductData = { "Guid": "00000000-0000-0000-0000-000000000000", "Name": "", "Description": "", "EAN": "", "Price": 0, "Vat": 25, "State": 1, "AllowManualRegistration": true, "ShowOnPricelist": false, "ProductGroup": {"Guid": "00000000-0000-0000-0000-000000000000", "Name": ""} };

	const navigate = useNavigate();

    function handleBankAccountChange(event){
        const BankAccountForm = document.getElementById('BankAccountForm');
        const formData = new FormData(BankAccountForm);
        const formDataObj = Object.fromEntries(formData.entries());

        var BankName = formDataObj.BankName;
        var ClnrNumber = formDataObj.ClnrNumber.replace(/[^0-9]/g, "").substring(0, 5);
        var AccountNumber = formDataObj.AccountNumber.replace(/[^0-9]/g, "").substring(0, 10);

        setBankAccount({ClnrNumber: ClnrNumber, AccountNumber : AccountNumber, BankName : BankName});
    }

    async function handleSave(e){
        e.preventDefault();

        //var CompleteAccountStr = ClnrNumber + '0'.repeat(15-ClnrNumber.length-AccountNumber.length) + AccountNumber;

        console.log(bankAccount.ClnrNumber + '0'.repeat(15-bankAccount.ClnrNumber.length-bankAccount.AccountNumber.length) + bankAccount.AccountNumber);
        let {resultVariant, resultVisible, resultText, errorsException} = await CallAPI('/api/admin/myinstance',"PATCH",JSON.stringify({BankAccount : bankAccount}));
        Refresh();
    }

    if (!loading && !registerDataLoading) {
        
        return (
            <ContentWrapper>

                <ModalAddShop     show={modalshowAddShop}     onHide={initModalAddShop}    refreshFunction={()=> { Refresh();}} ></ModalAddShop>
                <ModalProductEdit show={modalshowAddProduct} onHide={initModalAddProduct} editProductData={defaultProductData} registerData={registerData} refreshFunction={()=> { Refresh();}} ></ModalProductEdit>

                <Container>
                    <Sida>
						<Rubrik>Översikt</Rubrik>

                        <Alert variant="info"><b>Konto</b><br></br>
                            <StyckeInternal>
                                {data.Instance.Company           !== null && data.Instance.Company           !== "" && <>{data.Instance.Company}<br></br></> } 
                                {data.Instance.VATIdentification !== null && data.Instance.VATIdentification !== "" && <>{data.Instance.VATIdentification}<br></br></> } 
                                {data.Instance.Street            !== null && data.Instance.Street            !== "" &&<>{data.Instance.Street}<br></br></> } 
                                {data.Instance.Zip               !== null && data.Instance.Zip               !== "" && <>{data.Instance.Zip}&nbsp;{data.Instance.City}<br></br></> } 
                                {data.Instance.eMail             !== null && data.Instance.eMail             !== "" && <>{data.Instance.eMail}<br></br></> } 
                                {data.Instance.Phone             !== null && data.Instance.Phone             !== "" && <>{data.Instance.Phone}<br></br></> } 
                            </StyckeInternal>
                        </Alert>               

                        <Alert variant="info"><b>Utbetalning</b><br></br>
                            {/* Ifall kontonummer behövs för utbetalning */}
                            {(data.Instance.ThirdPartyTransaction == true && data.Instance.BankAccount.AccountNumber == 0 ) &&
                                <>
                                <StyckeInternal>Du behöver ange ett kontonummer för utbetalningar, utbetalningarna kommer att göras varje månadsskifte. Utbetalning sker endast till verifierat svenskt företagskonto.</StyckeInternal>

                                <Form id="BankAccountForm">
        
                                    <Form.Group className="mb-3" >
                                        <Form.Label><b><small>Namn på Bank</small></b></Form.Label>
                                        <Form.Control type="text" onChange={handleBankAccountChange} name="BankName" placeholder="Namn:"  />
                                    </Form.Group>

                                    <Form.Group className="mb-3" >
                                        <Form.Label><b><small>Clnr</small></b></Form.Label>
                                        <Form.Control type="text" onChange={handleBankAccountChange} name="ClnrNumber" placeholder="Clnr:" value={bankAccount.ClnrNumber} />
                                    </Form.Group>

                                    <Form.Group className="mb-3" >
                                        <Form.Label><b><small>Kontonummer</small></b></Form.Label>
                                        <Form.Control type="text" onChange={handleBankAccountChange} name="AccountNumber" placeholder="Kontonr:" value={bankAccount.AccountNumber}  />
                                    </Form.Group>

                                    <Form.Group className="mb-3">
                                        <Button
                                            className="contact-submit"
                                            variant="primary"
                                            type="submit"
                                            onClick={handleSave}
                                            // disabled={resultVariant == "success" ? true : false}
                                        >Spara</Button>
                                    </Form.Group>

                                    {(bankAccount.ClnrNumber.length>1 || bankAccount.AccountNumber.length>1 ) && <>
                                        {bankAccount.ClnrNumber + '0'.repeat(15-bankAccount.ClnrNumber.length-bankAccount.AccountNumber.length) + bankAccount.AccountNumber}<br></br><br></br>
                                    </>}

                                </Form>                                
                                </>
                            }

                            {(data.Instance.ThirdPartyTransaction == true && data.Instance.BankAccount.AccountNumber != 0 ) && <StyckeInternal>
                                Försäljningen betalas ut månadsvis till bankkonto: {data.Instance.BankAccount.ClnrNumber + '0'.repeat(15-data.Instance.BankAccount.ClnrNumber.length-data.Instance.BankAccount.AccountNumber.length) + data.Instance.BankAccount.AccountNumber}&nbsp;{data.Instance.BankAccount.BankName}
                            </StyckeInternal>}

                            {(data.Instance.ThirdPartyTransaction == true && data.Instance.BankAccount.AccountNumber != 0 ) && <>
                                <b>Swish</b><br></br>
                                <StyckeInternal>
                                    Har ditt företag Swish Handel så kan du få pengarna direkt in på ditt företagskonto. Du kan då utfärda ett certifikat på https://portal.swish.nu.
                                    Kontakta oss för att få en CSR-fil.
                                </StyckeInternal>
                            </>}                            

                            {(data.Instance.ThirdPartyTransaction == false  ) &&
                                <StyckeInternal>Din försäljning betalas ut till Swishkonto: {data.Instance.SwishIdentifier}<br></br>Nuvarande certifikat är giltligt tom: {SplitoutLocalDateFromISO(data.Instance.SwishCertValidUntil)}</StyckeInternal>
                            }                                                        
                        </Alert>

                        {(data.Instance.ShopCnt == 0) &&
                            <Alert variant="danger"><b>Du saknar butiker!</b><br></br>

                                <StyckeInternal>
                                    Innan du kan öppna din första butik så behöver du skapa den.
                                </StyckeInternal>
                                <Form.Group className="mb-3" >
                                        <Button className="QmeButton" style={{ backgroundColor: Branding().ButtonColor }} variant="primary" type="button" onClick={initModalAddShop}>Skapa butik</Button>
                                </Form.Group>

                            </Alert>
                        }


                        {(data.Instance.ShopCnt > 0) &&
                            <Alert variant="info"><b>Butiker</b><br></br>

                                <StyckeInternal>
                                    Du har totalt {data.Instance.ShopCnt} butiker.
                                </StyckeInternal>
                                <Form.Group className="mb-3" >
                                        <Button className="QmeButton" style={{ width: "auto", backgroundColor: Branding().ButtonColor }} variant="primary" type="button" onClick={initModalAddShop}>Skapa fler butiker</Button>
                                        <Button className="QmeButton" style={{ width: "auto", backgroundColor: Branding().ButtonColor }} variant="primary" type="button" onClick={() => navigate("/shops")}>Visa dina butiker</Button>                                        
                                </Form.Group>

                            </Alert>
                        }                                                                       

                        {(data.Instance.ProductCnt == 0) &&
                            <Alert variant="danger"><b>Du saknar varor!</b><br></br>
                                <StyckeInternal>
                                    Innan någon kan handla i din(a) butiker så behöver du lägga till varor.
                                </StyckeInternal>
                                <Form.Group className="mb-3" >                        
                                        <Button className="QmeButton" style={{ width: "auto", backgroundColor: Branding().ButtonColor }} onClick={initModalAddProduct}>Lägg till varor</Button>
                                </Form.Group>

                            </Alert>
                        }

                        {(data.Instance.ProductCnt > 0) &&
                            <Alert variant="info"><b>Varor och varugrupper</b><br></br>
                                <StyckeInternal>
                                    Du har totalt {data.Instance.ProductCnt} varor i din profil.<br></br>
                                    Du har totalt {data.Instance.ProductGroupCnt} varugrupper i din profil.<br></br>
                                </StyckeInternal>
                                <Form.Group className="mb-3" >                        
                                        <Button className="QmeButton" style={{ width: "auto", backgroundColor: Branding().ButtonColor }} onClick={initModalAddProduct}>Lägg till fler varor</Button>
                                        <Button className="QmeButton" style={{ width: "auto", backgroundColor: Branding().ButtonColor }} variant="primary" type="button" onClick={() => navigate("/products")}>Visa varor</Button>
                                        <Button className="QmeButton" style={{ width: "auto", backgroundColor: Branding().ButtonColor }} variant="primary" type="button" onClick={() => navigate("/productgroups")}>Visa varugrupper</Button>
                                </Form.Group>

                            </Alert>
                        }                         

                        {/* {(data.Instance.ProductGroupCnt == 0 || data.Instance.ProductsCnt == 0 || data.Instance.ShopCnt == 0 || true) &&
                            <Alert variant="danger">Innan du kan öppna din butik så är det lite som behöver fixas.<br></br>

                                <Form.Group className="mb-3" >

                                    {data.Instance.ProductGroupCnt != 0 && 
                                        <Button variant="danger" >Skapa produktgrupper</Button>
                                    }                            

                                    {data.Instance.ProductsCnt != 0 && 
                                        <Button variant="danger" onClick={initModalAddProduct}>Lägg till varor</Button>
                                    }
                                </Form.Group>

                            </Alert>
                        }                                                   */}

                    </Sida>
                </Container>
            </ContentWrapper>
        );
    } else {
        return (<Loading />);        
    }
}